import { Box, type BoxProps, TypographyStylesProvider, cx } from 'ui';

import classes from './Display.module.css';
import { getText, sanitize } from './utils';

interface DisplayProps extends BoxProps {
  html?: string;
  className?: string;
  withTypographyStyles?: boolean;
}

// This is needed to revert tailwind's list styles - DB

const ConditionalTypography = ({
  condition,
  wrapper,
  children,
}: {
  condition: boolean;
  wrapper: (children: React.ReactNode) => React.ReactNode;
  children: React.ReactNode | React.ReactNode[];
}) => (condition ? wrapper(children) : children);

/** Display a node with sanitized html */
const RichTextDisplay = ({ html, className, withTypographyStyles = true }: DisplayProps) => {
  const htmlSanitized = sanitize(html);

  return (
    <ConditionalTypography
      condition={withTypographyStyles}
      wrapper={(children: React.ReactNode) => (
        <TypographyStylesProvider>{children}</TypographyStylesProvider>
      )}
    >
      <Box
        className={cx(classes.display, className)}
        dangerouslySetInnerHTML={{ __html: htmlSanitized }}
      />
    </ConditionalTypography>
  );
};

RichTextDisplay.sanitize = sanitize;
RichTextDisplay.getText = getText;

export { RichTextDisplay };
